/* ============================================================
   Eye-Candy — dezente Mikrointeraktionen für Gardia.
   Alles degradiert sauber ohne JS und respektiert prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Feiner Pointer (Maus/Trackpad)? Touch bekommt keine Hover-Effekte.
  var finePointer = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ──────────────────────────────────────────────────────────
     #1 Count-up: <span data-countup="20000" data-countup-suffix="+">
     Zählt beim ersten Sichtbarwerden von 0 auf den Zielwert hoch.
     Tausenderpunkte (de-DE). Bei reduced-motion: sofort Endwert.
     ────────────────────────────────────────────────────────── */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup], [data-countup-auto]');
    if (!els.length) return;

    function format(n, decimals) {
      return n.toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    }

    // Für data-countup-auto: führenden Zahlenteil aus dem Text lösen.
    // "24/7" → { num: 24, prefix: '', suffix: '/7' }
    // "20k+" → { num: 20, prefix: '', suffix: 'k+' }
    // "ab 5" → { num: 5,  prefix: 'ab ', suffix: '' }
    function parseAuto(text) {
      var m = text.match(/^(\D*)([\d.,]+)(.*)$/);
      if (!m) return null;
      var prefix = m[1];
      var rawNum = m[2];
      var suffix = m[3];
      // Eingabe nutzt Punkt als Dezimaltrenner (z.B. "99.9"); Komma ebenso
      // unterstützen. Tausenderpunkte werden nicht erwartet (Werte ohne).
      var normalized = rawNum.replace(',', '.');
      var num = parseFloat(normalized);
      if (isNaN(num)) return null;
      var decimals = normalized.indexOf('.') !== -1
        ? normalized.split('.')[1].length : 0;
      return { num: num, prefix: prefix, suffix: suffix, decimals: decimals };
    }

    function run(el) {
      var target, suffix, prefix, decimals;

      if (el.hasAttribute('data-countup-auto')) {
        var parsed = parseAuto((el.textContent || '').trim());
        if (!parsed) return; // nichts Numerisches → Text unangetastet lassen
        target = parsed.num; prefix = parsed.prefix;
        suffix = parsed.suffix; decimals = parsed.decimals;
      } else {
        target = parseFloat(el.getAttribute('data-countup')) || 0;
        suffix = el.getAttribute('data-countup-suffix') || '';
        prefix = el.getAttribute('data-countup-prefix') || '';
        decimals = parseInt(el.getAttribute('data-countup-decimals'), 10) || 0;
      }
      var dur = parseFloat(el.getAttribute('data-countup-duration')) || 1600;

      if (reduced) { el.textContent = prefix + format(target, decimals) + suffix; return; }

      var start = null;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        // easeOutCubic
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + format(target * eased, decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = prefix + format(target, decimals) + suffix;
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ──────────────────────────────────────────────────────────
     #5 Scroll-Progress: dünne Leiste oben, füllt sich mit Scrolltiefe.
     Wird per JS in den body injiziert. CSS in app.css.
     ────────────────────────────────────────────────────────── */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('div');
    fill.className = 'scroll-progress__fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? (window.scrollY || window.pageYOffset) / h : 0;
      fill.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // ScrollSmoother feuert kein natives scroll auf window → GSAP-Ticker.
    (function waitForTicker() {
      if (window.gsap && window.gsap.ticker) window.gsap.ticker.add(update);
      else requestAnimationFrame(waitForTicker);
    })();
    update();
  }

  /* ──────────────────────────────────────────────────────────
     #8 Cursor-Glow: weicher Lichtkreis folgt dem Cursor auf dunklen
     Sections mit [data-cursor-glow]. Nur Desktop, nie bei reduced-motion.
     ────────────────────────────────────────────────────────── */
  function initCursorGlow() {
    if (reduced || !finePointer) return;
    var sections = document.querySelectorAll('[data-cursor-glow]');
    if (!sections.length) return;

    sections.forEach(function (sec) {
      var glow = document.createElement('div');
      glow.className = 'cursor-glow';
      glow.setAttribute('aria-hidden', 'true');
      sec.appendChild(glow);
      // Section muss als Positionierungskontext dienen.
      if (getComputedStyle(sec).position === 'static') sec.style.position = 'relative';

      sec.addEventListener('pointermove', function (e) {
        var r = sec.getBoundingClientRect();
        glow.style.setProperty('--gx', (e.clientX - r.left) + 'px');
        glow.style.setProperty('--gy', (e.clientY - r.top) + 'px');
        glow.style.opacity = '1';
      });
      sec.addEventListener('pointerleave', function () {
        glow.style.opacity = '0';
      });
    });
  }

  ready(function () {
    initCountUp();
    initScrollProgress();
    initCursorGlow();
    // #9 Button-Press ist rein CSS (.btn-fx:active) — kein JS nötig.
  });
})();
